import { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

const testimonials = [
  {
    quote: 'The GTBuy spreadsheet system completely transformed how I track orders across multiple platforms. The automation features alone save me 15 hours per week, and the profit dashboard gives me real-time visibility into my sourcing margins.',
    author: 'Marcus Chen',
    role: 'E-commerce Sourcing Agent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20modern%20business%20person%20with%20warm%20genuine%20expression%2C%20natural%20studio%20window%20light%2C%20soft%20cream%20wall%20background%2C%20casual%20blazer%20in%20sand%20tone%2C%20clean%20minimalist%20corporate%20headshot%20photography%2C%20confident%20approachable%20look%2C%20warm%20earthy%20color%20palette%2C%20no%20text%20no%20watermark&width=600&height=800&seq=testimonial-v3-01&orientation=portrait',
  },
  {
    quote: 'Switching from Kakobuy manual spreadsheets to the GTBuy automated system was the best decision I made in 2025. The comparison dashboard alone helped me identify which platforms deliver the best ROI for different product categories.',
    author: 'Sarah Mitchell',
    role: 'Dropshipping Entrepreneur',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20female%20entrepreneur%20with%20warm%20confident%20smile%2C%20natural%20studio%20lighting%20from%20left%2C%20soft%20beige%20wall%20background%2C%20modern%20casual%20business%20attire%20in%20neutral%20tones%2C%20clean%20minimalist%20headshot%20photography%2C%20friendly%20approachable%20energy%2C%20no%20text%20no%20watermark&width=600&height=800&seq=testimonial-v3-02&orientation=portrait',
  },
  {
    quote: 'As someone managing orders across Superbuy and multiple agent platforms, having everything unified in one spreadsheet is invaluable. The template library covers every use case I have encountered — from arbitrage tracking to bulk order management.',
    author: 'David Okonkwo',
    role: 'International Sourcing Manager',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20diverse%20business%20professional%20in%20modern%20office%20setting%2C%20warm%20natural%20afternoon%20light%2C%20cream%20textured%20wall%20background%2C%20button%20down%20shirt%20in%20earthy%20tan%20tone%2C%20confident%20business%20headshot%20photography%2C%20warm%20genuine%20expression%2C%20no%20text%20no%20watermark&width=600&height=800&seq=testimonial-v3-03&orientation=portrait',
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = useCallback(() => {
    setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  }, []);

  const next = useCallback(() => {
    setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));
  }, []);

  const t = testimonials[current];

  return (
    <section className="px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row gap-10 md:gap-14 items-center">
          <div className="w-full md:w-2/5">
            <div className="rounded-2xl overflow-hidden aspect-[3/4] w-full max-w-xs mx-auto md:max-w-none bg-accent-100">
              <img
                src={t.imageUrl}
                alt={t.author}
                title={t.author}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-full md:w-3/5 flex flex-col justify-center">
            <span className="text-xs font-medium text-accent-600 tracking-wider uppercase whitespace-nowrap">
              (Editor&apos;s Pick)
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mt-2 mb-1 leading-tight">
              What Professionals Say
            </h2>
            <h3 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-300 leading-tight mb-8">
              About GTBuy Spreadsheet
            </h3>

            <blockquote className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 italic">
              &ldquo;{t.quote}&rdquo;
            </blockquote>

            <p className="text-foreground-900 font-semibold text-sm whitespace-nowrap">
              &mdash; {t.author}, <span className="text-foreground-500 font-normal">{t.role}</span>
            </p>

            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={prev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-400 hover:text-foreground-700 hover:border-foreground-400 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/article/gtbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            Read the Full GTBuy Spreadsheet Guide
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}